import { Directive, HostListener, Input, Renderer2, ElementRef, AfterViewInit, inject } from '@angular/core';
import { NgControl } from '@angular/forms';
import { formatSSN } from '../../constants';

@Directive({ selector: '[appSSNInputMask]' })
export class SSNInputMaskDirective implements AfterViewInit {
     ngControl = inject(NgControl);
     private renderer = inject(Renderer2);
     private elem = inject(ElementRef);


     @Input() appSSNInputMask: boolean;

     ngAfterViewInit(): void {
     	if (this.appSSNInputMask) {

     		this.renderer.setAttribute(this.elem.nativeElement, 'maxlength', '11');

     		if (!this.elem.nativeElement.hasAttribute('placeholder') || (this.elem.nativeElement.hasAttribute('placeholder') && this.elem.nativeElement.getAttribute('placeholder').length === 0)) {
     			this.renderer.setAttribute(this.elem.nativeElement, 'placeholder', 'xxx-xx-xxxx');
     		}
     		else {
     			this.renderer.setAttribute(this.elem.nativeElement, 'placeholder', this.elem.nativeElement.getAttribute('placeholder') + ': xxx-xx-xxxx');
     		}
     	}
     }

     @HostListener('ngModelChange', ['$event'])
     onModelChange(event): void {
     	if (this.appSSNInputMask) {
     		this.onInputChange(event, false);
     	}
     }

     @HostListener('keydown.backspace', ['$event'])
     keydownBackspace(event): void {
     	if (this.appSSNInputMask) {
     		this.onInputChange(event.target.value, true);
     	}
     }


     onInputChange(event: string, backspace): void {
     	let newVal = event.replace(/\D/g, '');
     	if (backspace && newVal.length <= 4) {
     		newVal = newVal.substring(0, newVal.length - 1);
     	}

     	newVal = formatSSN(newVal);

     	this.ngControl.valueAccessor.writeValue(newVal);
     }
}
